import { messagesNow } from '@/i18n'
import { messages } from './messages'

/** Отказ сервера при загрузке файла: статус и серверный код, если он был в ответе. */
export class UploadError extends Error {
  readonly status: number
  readonly code: string | null

  constructor(status: number, responseText: string) {
    super(`Upload failed: ${status}`)
    this.name = 'UploadError'
    this.status = status
    this.code = readCode(responseText)
  }
}

// Ответ бэка: {"detail":{"code":"file_is_too_large_5_mb","detail":"..."}} или {"detail":"..."}.
const readCode = (text: string): string | null => {
  try {
    const body: unknown = JSON.parse(text)
    const detail = (body as { detail?: unknown }).detail
    const code = (detail as { code?: unknown } | null | undefined)?.code
    return typeof code === 'string' ? code : null
  } catch {
    return null
  }
}

const TOO_LARGE = /^file_is_too_large_(\d+)_mb$/

/**
 * Текст ошибки загрузки для автора. Серверные коды и «Upload failed: 413 {…}»
 * автору ничего не говорят: называем причину и что с этим делать.
 */
export const uploadErrorText = (error: unknown, kind: 'image' | 'video' = 'image'): string => {
  const m = messagesNow(messages)
  const what = kind === 'video' ? m.whatVideo : m.whatFile
  if (error instanceof UploadError) {
    const size = error.code ? TOO_LARGE.exec(error.code) : null
    if (size) return m.tooLargeMb(size[1])
    if (error.status === 413) return m.tooLarge
    if (error.status === 415 || error.status === 422) return m.badFormat
    if (error.status === 401 || error.status === 403) return m.noAccess
    if (error.status >= 500) return m.server(what)
  }
  if (error instanceof Error && error.message === 'Network error during upload') {
    return m.offline
  }
  return m.failed(what)
}
